import React from 'react';
import { useUserStore } from '../../../../modules/Auth/stores/authStore';
import { PlayerType } from '../../../models/video';
import PlayerSambatech from '../../atoms/PlayerSambatech';
import PlayerVimeo from '../../atoms/PlayerVimeo';
import PlayerYoutube from '../../atoms/PlayerYoutube';

//Se alterar alguma prop, lembrar de mudar a função de memoização
interface PlayerProps {
  playerType: PlayerType;
  token: string;
  initialTime: number;
  onFinish?: () => any;
  onFullFinish?: () => any;
  className?: string;
  contentId?: string;
}

const VideoPlayer: React.FC<PlayerProps> = (props) => {
  const { playerType = 'sambatech' } = props;
  const user = useUserStore().user;

  const videoQuality = user?.videoQuality || '360';

  const playerRenderers: Partial<
    Record<PlayerType, () => React.ReactElement>
  > = {
    sambatech: () => (
      <PlayerSambatech
        {...props}
        onVirtualFinish={props.onFinish}
        onFinish={props.onFullFinish}
      />
    ),
    samba: () => (
      <PlayerSambatech
        {...props}
        onVirtualFinish={props.onFinish}
        onFinish={props.onFullFinish}
      />
    ),
    vimeo: () => (
      <PlayerVimeo
        {...props}
        videoQuality={videoQuality}
        onVirtualFinish={props.onFinish}
        onFinish={props.onFullFinish}
      />
    ),
    youtube: () => <PlayerYoutube {...props} />,
  };

  const renderPlayer = () => {
    const Renderer = playerRenderers[playerType];
    return Renderer ? (
      <>
        <div data-content-id={props.contentId} />
        <Renderer />
      </>
    ) : (
      <div>Player não suportado</div>
    );
  };

  return (
    <div className={`h-full w-full ${props.className ?? ''}`}>
      {renderPlayer()}
    </div>
  );
};

const memoizedVideoPlayer = React.memo(VideoPlayer, (prevProps, nextProps) => {
  return (
    prevProps.playerType === nextProps.playerType &&
    prevProps.token === nextProps.token &&
    prevProps.initialTime === nextProps.initialTime &&
    prevProps.className === nextProps.className
  );
});

export default memoizedVideoPlayer;
